export const galleryPhotos = [
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-1.jpeg',
    alt: 'Gallery Photo 1'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-2.jpeg',
    alt: 'Gallery Photo 2'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-3.jpeg',
    alt: 'Gallery Photo 3'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-4.jpeg',
    alt: 'Gallery Photo 4'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-5.jpeg',
    alt: 'Gallery Photo 5'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-6.jpeg',
    alt: 'Gallery Photo 6'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-7.jpeg',
    alt: 'Gallery Photo 7'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-8.jpeg',
    alt: 'Gallery Photo 8'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-9.jpeg',
      alt: 'Gallery Photo 9'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-10.jpeg',
    alt: 'Gallery Photo 10'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-11.jpeg',
    alt: 'Gallery Photo 11'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-12.jpeg',
    alt: 'Gallery Photo 12'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-13.jpeg',
    alt: 'Gallery Photo 13'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-14.jpeg',
    alt: 'Gallery Photo 14'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-15.jpeg',
    alt: 'Gallery Photo 15'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-16.jpeg',
    alt: 'Gallery Photo 16'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-17.jpeg',
    alt: 'Gallery Photo 17'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-18.jpeg',
    alt: 'Gallery Photo 18'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-19.jpeg',
    alt: 'Gallery Photo 19'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-20.jpeg',
    alt: 'Gallery Photo 20'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-21.jpeg',
    alt: 'Gallery Photo 21'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-22.jpeg',
    alt: 'Gallery Photo 22'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-23.jpeg',
    alt: 'Gallery Photo 23'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-24.jpeg',
    alt: 'Gallery Photo 24'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/gallery-25.jpeg',
    alt: 'Gallery Photo 25'
  }
]

export const castPhotos = [
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/Elaine-Lim_climate_change_documentary.jpg',
    title: 'Elaine Lim',
    subtitle: 'Director, Producer',
    content: (
      <>
        <p>Elaine is an accomplished photographer with a passion for fine art and commercial photography. She studied commercial photography at RMIT, Melbourne. Elaine's dedication to the art of photography is reflected in her training in fine art photographic printing and her works have won her international awards.</p>
        <p>In 2009, Elaine co-founded White Room Studio, an award-winning portrait studio in Singapore that has won several prestigious accolades, including 8-time Singapore Tatler's 'Best Portrait Photographer' and Expat Living's Gold Winner for Best Photographer in Singapore.</p>
        <p>In addition to her artistic pursuits, Elaine is an experienced scuba diver and has developed an affection for marine diversity and life. Her daughter, Hillary O'Sullivan, shares her passion for protecting the planet and its oceans. Together, they are committed to promoting environmental conservation and awareness through their artistic and personal endeavours.</p>
      </>
    ),
    link: 'https://www.linkedin.com/in/elainelim-whiteroom'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/Hillary_OSullivan_climate_change_documentary.jpg',
    title: 'Hillary O\'Sullivan',
    subtitle: 'Narrator, Climate Ambassador, Pianist',
    content: (
      <>
        <p>Hillary is an accomplished young pianist from Singapore, and her musical journey began from the tender age of 3. An 11 times award-winning classical pianist, she has travelled to remote islands in Indonesia and Maldives, and surrounded by children and their parents, she performed in open air concerts to the sounds of nature. </p>
        <p>Hillary also has a deep love in photography, which led to her 2018 photo-documentary, called <a href='https://youtu.be/BKdiL0fZva4' rel='noopener noreferrer' target='_blank'>Above the Sands</a>, on the people of Bunaken, Indonesia. Hillary's project allowed her to capture the essence of the island's inhabitants, and she interviewed villagers from all walks of life to gain a deeper understanding of their culture.</p>
        <p>In 2023, she was invited to participate in the Antarctic Climate Expedition, and she made the long journey to Antarctica in February as the youngest Key Opinion Ambassador of the expedition. A piano music called “Rhapsody of a Changing Antarctic” was specially composed by for the expedition, and Hillary’s role was to use piano music to convey the dire straits all humanity faces with the drastic climate changes we face.</p>
        <p>2 of her photographs she took in Antarctic was exhibited at Singapore’s Botanical Gardens at the “<a href='https://cdl.com.sg/newsroom/melting-ice-sinking-cities-an-exhibition-on-the-interconnectedness-of-climate-change-melting-glaciers-our-ocean-and-singapores-coastal-resilience' rel='noopener noreferrer' target='_blank'>Melting Ice and Sinking Cities</a>” Photo Exhibition in June 2023.</p>
        <p>Since coming back from Antarctica, Hillary has been interviewed by <a href='https://www.youtube.com/watch?v=bhGgHBIba0Y' rel='noopener noreferrer' target='_blank'>CNA Live on TV News</a>, as well as <a href='https://www.todayonline.com/singapore/pianist-antarctic-expedition-climate-change-2176706' rel='noopener noreferrer' target='_blank'>Today Online</a> about her contributions towards using music to articulate the global problem of climate change. She has presented her interviews of the experts and activists during the Antarctic trip to her school in Singapore, so as to share and advocate for climate awareness with her peers.</p>
        <p>Hillary was approved to perform “Rhapsody of a Changing Antarctic” at the Royal Highland Festival in 2023. His Majesty The King has envisioned the Royal Highland Festival in 2016 to preserve and celebrate the highland culture and traditions of Bhutan while contributing to their socio-economic development. The Festival aims to showcase Bhutan’s highland culture while promoting Bhutan’s efforts around climate resilience. Hillary’s participation benefited the Festival and the larger Highland Sustainability Initiative in promoting its message on climate change and sustainability for Bhutan.</p>
      </>
    ),
    link: 'https://www.youtube.com/@hillaryosullivan'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/Karma-Kencho_climate_change_documentary.jpg',
    title: 'Karma Kencho',
    subtitle: 'Director of Photography, Scriptwriter, Camera Man, Editor',
    content: (
      <>
        <p>Karma Kencho is a Bhutanese photographer, videographer, filmmaker and cultural tour guide with a passion for storytelling and preserving the rich heritage of Bhutan. Born in 1981, Karma has a deep connection to the natural beauty and culture of his homeland. His career began with a love for portrait, landscape, and wildlife photography, which led him to establish himself as a skilled filmmaker and nature guide.</p>
        <p>Karma is also actively involved in the tourism industry, offering unique cultural tours that highlight the essence of Bhutan’s traditions and landscapes.</p>
        <p>In addition to his work in photography and guiding, Karma is a filmmaker. His first film, “The Ox Song”, co-directed with Kinley Tshering, showcases his storytelling abilities and dedication to showcasing Bhutanese life through visual arts. Karma’s commitment to his craft is evident in his projects, which emphasize unity among Bhutan’s diverse ethnic groups. </p>
        <p>He is also an advocate for promoting accessible tourism, believing that everyone should have the opportunity to experience Bhutan's unique charm.  Karma is always learning and expanding his artistic pursuits, while continuing to share his love for Bhutan with the world.</p>
      </>
    ),
    link: 'https://www.facebook.com/karma.kencho.5'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/Tashi-Tobgye_climate_change_documentary.jpg',
    title: 'Tashi Tobgay',
    subtitle: 'Camera Man, Editor',
    content: (
      <>
<p>Tashi Tobgay is a professional portrait photographer and videographer with over five years of experience in the media industry. His expertise lies in capturing the essence of people through his lens, creating powerful and emotive visual stories. Throughout his career, Tashi has worked on various projects, honing his skills and establishing himself as a respected figure in the field. Currently, he serves as the Media Focal Person at Bhutan’s Dessup Skilling Program, where he plays a key role in managing and overseeing media related initiatives. His dedication and creative vision continue to drive his success in the world of photography and videography.</p>
      </>
    ),
    link: 'https://www.instagram.com/tee_tee_photograph/'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/Mani-Dorji_climate_change_documentary.jpg',
    title: 'Mani Dorji',
    subtitle: 'Production Coordinator',
    content: (
      <>
        <p>Mani Dorji is a passionate tour guide dedicated to crafting unforgettable experiences for travelers from all walks of life. With 25 years of experience in the Tourism industry and 12 years of Guiding, He believes that every journey is an opportunity to create lasting memories and connections.</p>  
        <p>Mani was a dedicated tour coordinator at the most luxurious resort in Bhutan, Amankora, for 7 years, before joining renowned travel agency Amala Destinations, Singapore. For 12 years, he brought his insightful experiences on tour coordination and designed authentic experiences for a generation of travellers who demanded the best of their time in Bhutan. The legacy of those years came into focus in 2023, when he founded Gayuel Destinations, a bespoke travel agency based in Bhutan, which brought Mani’s talented expertise in cultural and adventure guiding to many travellers seeking to experience the best Bhutan offers.</p>
        <p>With a keen eye for detail and a passion for storytelling, Mani strives to create an authentic and immersive experience for every traveller. From hidden gems to popular landmarks, he always on the lookout for new and exciting ways to showcase the beauty and diversity of each destination.</p>
      </>
    ),
    link: 'https://gayueldestination.com/'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/Tshering-Dorji_climate_change_documentary.JPG',
    title: 'Tshering Dorji',
    subtitle: 'Singer',
    content: (
      <>
        <p>Tshering Dorji is a Bhutanese movie personality. One of the most talented and versatile artists in Bhutan, he loved singing, dancing, and acting since his childhood. His acting skills came to notice when he performed at his first theater in 2004. Since then, Tshering has went on to be known for his captivating performances and indomitable spirit. His unique voice is well respected and in 2023, he sang a touching tribute song for Bhutan’s 116th National Day. </p>
      </>
    ),
    link: 'https://www.instagram.com/btntsheringdorji'
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/Eric-Bettens_climate_change_documentary.jpg',
    title: 'Eric Bettens',
    subtitle: 'Composer',
    content: (
      <>
        <p>Eric Bettens is a Belgian artist, passionate about this music which has punctuated his life since a young age. Today, in addition to film sound and the composition of instrumental and orchestral works, he combines electronic and acoustic instruments with sounds captured in nature to compose eclectic and original works which have earned him numerous prestigious awards. He wrote the music “Rhapsody of the Changing Antarctic” for the 2023 Antarctic Climate Expedition, drawing his inspiration from the sumptuous ice landscapes whilst depicting the dire straits Antarctica faced due to climate change.</p>
      </>
    ),
    link: 'https://www.ericbettens.com'
  },
  // {
  //   src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/Rabsel-Dorji_climate_change_documentary.jpg',
  //   title: 'Rabsel Dorji',
  //   subtitle: 'His Majesty’s Secretriat Advisor',
  //   content: (
  //     <>
  //       <p>Rabsel Dorji works for His Majesty the King’s Secretariat in Bhutan, and is engaged in the Gelephu Mindfulness City project, a new Special Administrative Region in Bhutan envisioned as the world’s first economic hub where vibrant development and growth co-exist in harmony with nature, supporting mindful, spiritual, and holistic living.</p>
  //       <p>Prior to this new role, he was an entrepreneur with interests in Tourism, Education, and Entrepreneurship. Besides managing his businesses, including a travel agency, he has also taught Business and Tourism at the Royal Thimphu College, wrote strategy papers on Tourism for the UNDP and Tourism Council of Bhutan, and served as a Board Director of the Association of Bhutanese Tour Operators.</p>
  //     </>
  //   )
  // }
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/royal-bhutan.jpeg',
    title: 'Royal Highland Festival',
    subtitle: 'Partner',
    content: (
      <>
        <p>The Royal Highland Festival is an annual cultural event held in Bhutan's Laya region, designed to celebrate the rich heritage, traditions, and lifestyles of the highland communities. The festival, initiated in 2016 by the King of Bhutan, aims to promote sustainable tourism, highlight the resilience of highland cultures, and encourage environmental conservation. Set against the stunning backdrop of the Himalayan mountains, the event showcases traditional sports, music, and crafts, while fostering a deeper connection between locals and visitors.</p>
      </>
    )
  },
  {
    src: 'https://shazanahhassan.s3.ap-southeast-1.amazonaws.com/gap/White-Room-Studio_climate_change_documentary.jpg',
    title: 'White Room Studio',
    subtitle: 'Production Company',
    content: (
      <>
        <p>White Room Studio, Singapore is an award-winning photography studio in Singapore. In 2024, White Room Studio celebrates its 8th consecutive award as Tatler’s “Best Portrait Photography Studio in Singapore”, clinching the title in the Best of Singapore awards between 2017 and 2024. Its 15-strong team, which has more than 75 years of experience combined, has been telling the stories of families, milestones, and important anniversaries for the past 15 years.</p>
        <p>Co-founded in 2009 by sibling team Elaine Lim and Dan Yeo, the photography studio has worked with more than 10,000 clients — ranging from companies to families — to capture an extensive array of occasions and achievements. It is supported by an award-winning team of accomplished and prolific photographers trained in creative direction and delivering a tailored experience for each client.</p>
      </>
    ),
    link: 'https://www.whiteroomstudio.com.sg'
  },
  {
    src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/kerry-consulting.jpg',
    title: 'Kerry Consulting',
    subtitle: 'Sponsor',
    content: (
      <>
        <p>Founded in 2003, Kerry Consulting is Singapore's leading executive recruitment firm. Comprising specialist recruiters with extensive networks across the Asia-Pacific region, the firm is committed to delivering positive long-term outcomes for both clients and candidates. This commitment is underpinned by the consultancy’s guiding principle of “Returning the Human to Resourcing”.</p>
      </>
    ),
    link: 'https://www.kerryconsulting.com'
  },
  {
    src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/Gayuel-Destination.jpg',
    title: 'Gayuel Destination',
    subtitle: 'Trek Guide',
    content: (
      <>
        <p>Gayuel Destination is a bespoke travel agency based in Bhutan, which brought 15 years of experience and talented expertise in cultural and adventure guiding to many travellers seeking to experience the best Bhutan offers.</p>
        <p>Custom activities tourism in Bhutan offers a range of unique experiences tailored to individual interests. From cultural tours to birdwatching, photography expeditions, and culinary adventures, visitors can immerse themselves in Bhutanese traditions and explore the country’s natural beauty. Customized itineraries allow for personalized experiences that showcase the best of Bhutan’s rich heritage and breathtaking landscapes.</p>
      </>
    )
  },
  {
    src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/Kupar-Graphy.png',
    title: 'Kupar Graphy',
    subtitle: 'Cinematographer',
    content: (
      <>
        <p>Kupar Graphy specializes in photography, videography, documentary and filmmaking, creating content that reflects the rich culture, breathtaking landscapes, and vibrant wildlife of Bhutan. Guided by a deep love for storytelling, their compelling visual content tells a story, showcases a brand, or capture moments in time, and resonates with audiences both locally and internationally.</p>

        <p>Founded by Karma Kencho, a talented filmmaker, photographer and cultural tour guide from Bhutan, Kupar Graphy’s team of skilled creatives is dedicated to delivering high quality photography and film production services. With over a decade of experience creating content that reflects the rich culture, breathtaking landscapes and vibrant wildlife of Bhutan, the team documents profound stories that make each journey into Bhutan unique.</p>
      </>
    )
  }
]

// export const climateAwarenessLearnMore = [
//   {
//     id: 1,
//     src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/climate-awareness/image1.png'
//   },
//   {
//     id: 2,
//     src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/climate-awareness/image2.png'
//   },
//   {
//     id: 3,
//     src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/climate-awareness/image3.png'
//   },
//   {
//     id: 4,
//     src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/climate-awareness/image4.png'
//   },
//   {
//     id: 5,
//     src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/climate-awareness/image5.png'
//   },
//   {
//     id: 6,
//     src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/climate-awareness/image6.jpg'
//   },
//   {
//     id: 7,
//     src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/climate-awareness/image7.png'
//   },
//   {
//     id: 8,
//     src: 'https://s3.ap-southeast-1.amazonaws.com/thegirlandherpiano.com/assets/climate-awareness/image8.png'
//   }
// ]